import { createType } from './create-type.js';
import { BooleanTypeDescription } from './boolean-type-description.js';

export const boolean: () => BooleanTypeDescription = () =>
  createType<BooleanTypeDescription>({
    description: { type: 'boolean' },
  });
